export default __webpack_public_path__ + "static/media/icon3.61b3942a.svg";